import {
  createAction,
  createActionGroup,
  emptyProps,
  props,
} from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { FrequentlyAskedQuestion } from './frequently-asked-question.model';

export const FrequentlyAskedQuestionActions = createActionGroup({
  source: 'FrequentlyAskedQuestion/API',
  events: {
    'Load FrequentlyAskedQuestions': emptyProps(),
    'Load FrequentlyAskedQuestions Success': props<{ frequentlyAskedQuestions: FrequentlyAskedQuestion[]; }>(),
    'Load FrequentlyAskedQuestions Failure': props<{ error: any }>(),


    'Add FrequentlyAskedQuestion': props<{ frequentlyAskedQuestion: FrequentlyAskedQuestion }>(),
    'Add FrequentlyAskedQuestion Success': props<{ frequentlyAskedQuestion: FrequentlyAskedQuestion; }>(),
    'Add FrequentlyAskedQuestion Failure': props<{ error: any; }>(),

    'Update FrequentlyAskedQuestion': props<{ frequentlyAskedQuestion: FrequentlyAskedQuestion }>(),
    'Update FrequentlyAskedQuestion Success': props<{ frequentlyAskedQuestion: Update<FrequentlyAskedQuestion> }>(),
    'Update FrequentlyAskedQuestion Failure': props<{ error: any }>(),

    'Delete FrequentlyAskedQuestion': props<{ uniqueId: string }>(),
    'Delete FrequentlyAskedQuestion Success': props<{ uniqueId: string }>(),
    'Delete FrequentlyAskedQuestion  Failure': props<{ error: any }>(),


    'Upsert FrequentlyAskedQuestion': props<{
      frequentlyAskedQuestion: FrequentlyAskedQuestion;
    }>(),
    'Add FrequentlyAskedQuestions': props<{
      frequentlyAskedQuestions: FrequentlyAskedQuestion[];
    }>(),
    'Upsert FrequentlyAskedQuestions': props<{
      frequentlyAskedQuestions: FrequentlyAskedQuestion[];
    }>(),
    'Update FrequentlyAskedQuestions': props<{
      frequentlyAskedQuestions: Update<FrequentlyAskedQuestion>[];
    }>(),
    'Delete FrequentlyAskedQuestions': props<{ ids: string[] }>(),
    'Clear FrequentlyAskedQuestions': emptyProps(),
  },
});
